// extracted by mini-css-extract-plugin
module.exports = {"searchPageHeader":"NkhlX"};